"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusOptions = exports.validationConfig = exports.initialArticleValues = exports.columns = exports.INITIAL_VISIBLE_COLUMNS = exports.LayoutType = void 0;
var LayoutType;
(function (LayoutType) {
    LayoutType["LIST"] = "list";
    LayoutType["GRID"] = "grid";
})(LayoutType = exports.LayoutType || (exports.LayoutType = {}));
exports.INITIAL_VISIBLE_COLUMNS = ["title", "status", "categories", "tags", "featured", "publish_date", "actions"];
exports.columns = [
    { name: "Title", uid: "title", sortable: true },
    { name: "Status", uid: "status", sortable: true },
    { name: "Categories", uid: "categories", sortable: false },
    { name: "Tags", uid: "tags", sortable: false },
    { name: "Featured", uid: "featured", sortable: true },
    { name: "Publish Date", uid: "publish_date", sortable: true },
    { name: "Actions", uid: "actions", sortable: false },
];
exports.initialArticleValues = {
    _id: "",
    title: "",
    body: "",
    status: "draft",
    categories: [],
    tags: [],
    featured: false,
    publish_date: "",
    summary: "",
    images: [],
};
exports.validationConfig = {
    title: { required: true },
    body: { required: true },
    status: { required: true },
    publish_date: { required: false },
    categories: { required: false },
    tags: { required: false },
    featured: { required: false },
    summary: { required: false },
    images: { required: false },
};
exports.statusOptions = [
    { value: "", label: "All Statuses" },
    { value: "draft", label: "Draft" },
    { value: "published", label: "Published" },
    { value: "scheduled", label: "Scheduled" },
];
